import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../../constants/Common';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import capitalGoodsAPI from '../../../../../services/modules/IP/capitalGoodAPI';
import capitalGoodsJSON from '../../../../../services/modules/JSON/capitalGoods';
import AverageForm from '../../../../Forms/AverageForm';
import Loader from '../../../../Loader/Loader';
import {IComponentProps} from '../../../Common/perquisiteMaster';

const CapitalGoodAverageBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year,
    method: 'Average'
  };
  const [editData, setEditData] = useState<any>(undefined);

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        capitalGoodsAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      capitalGoodsJSON()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          setEditData(res1?.data);
          onValuesChange(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        onValuesChange(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <AverageForm
        setSubmitDisabled={() => {}}
        suppliers={[]}
        isAverage={true}
        data={editData}
        setFormFacility={() => {}}
        setFormSelectedYear={() => {}}
        defaultDisplayStep={true}
      />
    </Form>
  );
};

export default CapitalGoodAverageBills;
